module.exports = __webpack_public_path__ + "static/media/reportsWitnessLogo.34a620d3.webp";